import React, { useContext, useRef, useState, useEffect } from 'react';

import { useContainer } from '../../../../hooks/useContainer'
import { AppContext } from "../../../../providers/appProvider"
import ErrorModal from '../../../UI/ErrorModal/ErrorModal';
import ContainerDeleteModal from '../Delete/Delete'; 

import tbl from '../../../../assets/Style/Table.module.css'
import Flag from '../../../UI/Flag/Flag';

import cl from './ContainerList.module.css'
import EditContainer from '../Edit/Edit';  
import Bl from '../Pdf/Bl';
import Consignment from '../Pdf/Consignment';
import InvoiceCargo from '../Pdf/InvoiceCargo';
import InvoiceContainer from '../Pdf/InvoiceContainer';
import { useCargo } from '../../../../hooks/useCargo';
import AddCargoModal from '../Cargo/AddCargo/AddCargo';
import EditCargoModal from '../Cargo/EditCargo/EditCargo';
import CargoDeleteModal from '../Cargo/DeleteCargo/Delete';
import ContainerAmountModal from '../Amounts/ContainerAmountModal/ContainerAmountModal';
import CargoAmountModal from '../Amounts/CargoAmountModal/CargoAmountModal';
import StatusDropdown from '../StatusDropdown/StatusDropdown';
import ImageModal from '../ImageModal/ImageModal';
import FileModal from '../FileModal/FileModal';
import ContainerLogo from "../../../../assets/Icon/ContainerIcon"; 
import Container from "../../../../assets/Icon/Container";
import BLicon from "../../../../assets/Icon/BLicon";
import BookingNum from "../../../../assets/Icon/BookingNum";
import Ship from "../../../../assets/Icon/Ship";
import Number from "../../../../assets/Icon/Number";
import Seal from "../../../../assets/Icon/Seal";
import Building from "../../../../assets/Icon/Building"; 
import Plus from '../../../../assets/Icon/Plus';
import UserI from '../../../../assets/Icon/User';
import Pen from '../../../../assets/Icon/Pen';
import Kilogram from '../../../../assets/Icon/Kilogram'; 
import Comment from '../../../../assets/Icon/Comment';
import Refresh from '../../../../assets/Icon/Refresh';
import Check from '../../../../assets/Icon/Check';
import Train from '../../../../assets/Icon/Train'; 
import Calendar from '../../../../assets/Icon/Calendar'; 
import Time from '../../../../assets/Icon/TimeB'; 
import ArrowFork from '../../../../assets/Icon/ArrowFork';
import Popover from '../../../UI/Popover/Popover';
import InvoiceModal from '../InvoiceModal/InvoiceModal';
import TitleFile from '../TitleFile/TitleFile';
import TransportPrice from './TransportPrice/TransportPrice';
import CargoImageModal from '../CargoImageModal/ImageModal'; 
import Green from '../Inputes/Green/Green';
import BankModal from '../Banks/BankModal';

const Item = ({container, index, containerService, openRemarkModal, searchTerm}) => {
 
    const { cargoService } = useCargo(-1);

    const { appState, app } = useContext(AppContext);
    
    const [isVisibleRedistribute, setIsVisibleRedistribute] = useState(false);  

    const handleRedistribute = () => { 
        containerService.distributePrice(container.id)   
    };

    const formatDate = (dateString) => {

    if (!dateString) return "- - -";

    const createdAtDate = new Date(dateString);

    if (isNaN(createdAtDate)) return "- - -";


    const months = [
        "იან",
        "თებ",
        "მარ",
        "აპრ",
        "მაი",
        "ივნ",
        "ივლ",
        "აგვ",
        "სექ",
        "ოქტ",
        "ნოე",
        "დეკ"
    ];

    const day = createdAtDate.getDate();
    const month = months[createdAtDate.getMonth()];
    const year = createdAtDate.getFullYear();
    const hours = createdAtDate.getHours().toString().padStart(2, '0');
    const minutes = createdAtDate.getMinutes().toString().padStart(2, '0');

    // return `${day} ${month} ${year} ${hours}:${minutes}`;
    return `${day} ${month} ${year} `;
    };


    const [isOpenAddCargo, setIsOpenAddCargo] = useState(false);
    const [openCargoIndex, setOpenCargoIndex] = useState(null);

    const openAddCargo = (index) => {
        setIsOpenAddCargo(true);
        setOpenCargoIndex(index);
    };

    const closeAddCargo = () => {
    setIsOpenAddCargo(false);
    setOpenCargoIndex(null);
    };
    
    
    const [isOpenEdit, setIsOpenEdit] = useState(false);
    const [openEditIndex, setOpenEditIndex] = useState(null);

    

    const openEdit = (index) => {
        setIsOpenEdit(true);
        setOpenEditIndex(index);

        setClientPrice(container.client_total_price);  
        setCompanyPrice(container.total_price);  
    
    };

    const closeEdit = () => {
        setIsOpenEdit(false);
    };

  
    
    const [isOpenEditCargo, setIsOpenEditCargo] = useState(false);
    const [isOpenEditCargoIndex, setOpenEditCargoIndex] = useState(null);

    const openEditCargo = (index) => {
        setIsOpenEditCargo(true);
        setOpenEditCargoIndex(index);
    };

    const closeEditCargo = () => {
        setIsOpenEditCargo(false);
        setOpenEditCargoIndex(null);
    };

 
    const [openedDropdownId, setOpenedDropdownId] = useState(null);
    const dropdownRef = useRef(null);

    const toggleDropdown = (containerId) => {
    if (openedDropdownId === containerId) {
        setOpenedDropdownId(null);  
    } else {
        setOpenedDropdownId(containerId);  
    }
    };

    useEffect(() => { 
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setOpenedDropdownId(null);
            }
        }; 
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


 

    const [selectedCargos, setSelectedCargos] = useState([]);

    const handleCargoSelect = (selectedCargo) => {
        setSelectedCargos(prevSelectedCargos => {
            if (prevSelectedCargos.some(cargo => cargo.id === selectedCargo.id)) {
                // Deselect cargo
                return prevSelectedCargos.filter(cargo => cargo.id !== selectedCargo.id);
            } else {
                // Select cargo
                return [...prevSelectedCargos, selectedCargo];
            }
        });
    };
    
     
 

    const getTotalCargoDebt = (cargos) => {

        if (!Array.isArray(cargos)) {
            return 0;
        }
  
        const totalDebt = cargos.reduce((total, cargo) => total + (cargo.total_debt || 0), 0);
        return totalDebt;

    };


    const handleClick = () => {
        containerService.containerCars(container.id)
    };


    const getLabelById = (id) => {
        const option = appState.initialTypeOptions.find(option => option.value === id);
        return option ? option.label : '- - -';
    };

    
 

    const [isOpenClientPrice, setIsOpenClientPrice] = useState(false);
    const [openClientPriceIndex, setOpenClientPriceIndex] = useState(null);

    const openClientPrice = (index) => {
        setIsOpenClientPrice(true);
        setOpenClientPriceIndex(index);
    };
 

    const [isOpenCompanyPrice, setIsOpenCompanyPrice] = useState(false);
    const [openCompanyPriceIndex, setOpenCompanyPriceIndex] = useState(null);

    const openCompanyPrice = (index) => {
        setIsOpenCompanyPrice(true);
        setOpenCompanyPriceIndex(index);
    };


    const [clientPrice, setClientPrice] = useState(container.client_total_price);
    const [companyPrice, setCompanyPrice] = useState(container.total_price);

    const handleUpdateClientPrice = (newPrice) => {
        setClientPrice(newPrice);  
    };
    

    const handleUpdateCompanyPrice = (newPrice) => {
        setCompanyPrice(newPrice);  
    };
    

  
      const highlightText = (text, highlight) => {
        if (!highlight) return text;
            const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
            return parts.map((part, index) =>
                part.toLowerCase() === highlight.toLowerCase() ? (
                    <mark key={index}>{part}</mark>
                ) : (
                    part
                )
            );
      };
    
      
      const getTotalCargoPrice = (cargos) => {
        if (!Array.isArray(cargos) || cargos.length === 0) {
            return ''; // Return an empty string if `cargos` is not an array or is empty
        }
    
        const totalPrice = cargos.reduce((total, cargo) => total + (cargo.cargo_price || 0), 0);
        if (totalPrice === 0) {
            return '';
        }
        return totalPrice;
    };
    
    return <>

     

        <div className={cl.containerBox}  style={(container.color && container.color.length > 4) ? { border:  'solid 2px  '+ container.color  } : {}} >

           
                {/* კონტეინერის ნახვა  */} 
 
              
                    <div className={cl.containerItem} style={{ borderBottom: '1px dashed var(--border-color)', marginBottom: '25px', padding: '11px 15px', width: '100%' }}> 
                            
                            <div className={ cl.containerFlex }> 
                                <span className={cl.btnContainerTop}>
                                    <span className={cl.icon}> ID  </span> {container.container_price == null ? 0 : container.container_price.id}
                                </span>
                            </div>
                            
                            <div className={ cl.containerFlex }> 


                                        {isOpenEdit && openEditIndex === index ? 
                                            <>    
                                                <span  className={cl.btnContainerTop}  onClick={() => { openEdit(null);  setOpenEditIndex(null);  } }>
                                                    <span className={cl.icon}><Pen/></span> რედაქტირება
                                                </span> 
                                            </>     
                                        : 
                                            <>
                                                <span  className={cl.btnContainerTop}  onClick={() => { openEdit(index);  setOpenEditIndex(index);  } }>
                                                    <span className={cl.icon}><Pen/></span> რედაქტირება
                                                </span> 
                                            </>
                                        }

                            </div>

                            <div className={ cl.containerFlex }> 
                                <span className={cl.btnContainerTop}
                                        
                                        onClick={() => openRemarkModal(container.color, container.id, 1)}>
                                    <span className={cl.icon}> <Comment/>  </span>კომენტარები
                                </span>
                            </div>

                            <div className={ cl.containerFlex }>
                                <InvoiceContainer defaultContainer={container}  
                                    cargoWeight={ 
                                        container.cargos && container.cargos.length > 0 ? 
                                        container.gross_weight / container.cargos.length : 
                                            0 
                                        }
                                    disabled={!app.hasPermission("INVOICE_SHOW")}/>
                            </div>
                            <div className={ cl.containerFlex } style={{ display: 'none' }}> 
                               <Bl containerService={containerService} defaultContainer={container}></Bl>
                            </div>
                            <div className={ cl.containerFlex }> 
                                <InvoiceModal containerService={containerService} defaultContainer={container} > </InvoiceModal>
                            </div>
 
                            <div className={ cl.containerFlex }> 
                                <FileModal containerService={containerService} defaultContainer={container}  disabled={!app.hasPermission("FILE_ADD")} />
                            </div>
                            <div className={ cl.containerFlex }>
                                <ImageModal containerService={containerService} defaultContainer={container} disabled={!app.hasPermission("PICTURE_ADD")} />
                            </div>
                            <div className={ cl.containerFlex }> 
                            {app.hasPermission("CONTAINER_DELETE") &&
                                <ContainerDeleteModal containerService={containerService} defaultContainer={container}> </ContainerDeleteModal>
                            } 
                            </div>
                            <div  className={ cl.containerFlex } >
                                <div  style={{display: 'none' }} >
                                    <div className={ cl.containerDetail + ' ' + cl.containerNum  }   onClick={() => toggleDropdown(container.id)}>
                                        <ContainerLogo/>  ნავიგაცია
                                    </div>

                                    {openedDropdownId === container.id && (
                                        <div className={ cl.dropdownContent } ref={dropdownRef}> 
                                            {
                                                (!container.hasOwnProperty('is_deleted') && !container.hasOwnProperty('is_archive')) && (
                                                <> 

                                                </>
                                                )
                                            }
                                        </div> 
                                    )}
                                </div>
                            </div>


                            <div style={{ display: 'none' }} className={ cl.containerFlex }>
                                <span className={cl.btnContainerTop} onClick={handleClick}>
                                    <span className={cl.icon}><Refresh/></span> შევსება
                                </span>
                            </div>

                            <div  className={ cl.containerFlex }></div>
                            <div  className={ cl.containerFlex }></div>

 

                            {  (container.hasOwnProperty('is_archive')) && ( 
                                                    <div className={ cl.archive_box } ><div>არქივი</div></div>
                                                
                                )
                            }


                    </div>


                    {isOpenEdit && openEditIndex === index ? 
                            <EditContainer 
                                containerService={containerService}
                                defaultContainer={container} 
                                onCloseEdit={() => { setIsOpenEdit(false);  setOpenedDropdownId(null);  } }  
                                onUpdateClientPrice={handleUpdateClientPrice}
                                onUpdateCompanyPrice={handleUpdateCompanyPrice}
                            ></EditContainer> 
                        : 
                    <>

                        <div className={ cl.containerItem } style={{marginBottom: '15px' }}>
                    
                            

                            <div className={ cl.containerFlex }>
                                <div className={ cl.containerDetail }>
                                <Container/>
                                    <div className={ cl.containerName }>კონტეინერი</div>
                                    <div className={ cl.containerValue }>
                                        {container.container_number ? 
                                            highlightText(container.container_number, searchTerm)
                                        : '- - -'
                                        } 
                                    </div>
                                </div>
                            </div>

                            <div className={ cl.containerFlex }>
                                <div className={ cl.containerDetail }>
                                <BLicon/>
                                    <div className={ cl.containerName }>BL ნომერი</div>
                                    <div className={ cl.containerValue }>
                                        {container.bl_number ? 
                                            highlightText(container.bl_number, searchTerm)
                                        : '- - -'
                                        } 
                                    </div>
                                </div>
                            </div>

                            <div className={ cl.containerFlex }>
                                <div className={ cl.containerDetail }>
                                <BookingNum/>
                                <div className={ cl.containerName }>Booking ნომერი</div>
                                <div className={ cl.containerValue }>
                                    {container.booking_number ? 
                                        highlightText(container.booking_number, searchTerm)
                                    : '- - -'
                                    } 
                                </div>
                                </div>
                            </div>

                            <div className={ cl.containerFlex }>
                                <div className={ cl.containerDetail }>
                                <Seal/>
                                <div className={ cl.containerName }>Seal ნომერი</div>
                                <div className={ cl.containerValue }>{container.seal_number || '- - -'}</div>
                                </div>
                            </div>

                            <div className={ cl.containerFlex }>
                                <div className={ cl.containerDetail }>
                                    <Number/>
                                    <div className={ cl.containerName }>Voyage ნომერი</div>
                                    <div className={ cl.containerValue }>{container.voyage_number || '- - -'}</div>
                                </div>
                            </div>

                            <div className={ cl.containerFlex }>
                                <div className={ cl.containerDetail }>
                                <Ship/>
                                <div className={ cl.containerName }>გემის სახელი</div>
                                <div className={ cl.containerValue }>{container.ship_name || '- - -'}</div>
                                </div>
                            </div>

                            <div className={ cl.containerFlex }>
                                <div className={ cl.containerDetail }>
                                <Building/>
                                <div className={ cl.containerName }>შიპერი</div>
                                <div className={ cl.containerValue }>{container.shipper ? container.shipper.name : '- - -'}</div>
                                </div>
                            </div>

                            <div className={ cl.containerFlex }>
                                <div className={ cl.containerDetail }>
                                    <Ship/>
                                    <div className={ cl.containerName }>საზღვაო ხაზი</div> 
                                    <div className={ cl.containerValue }>{container.marine_line ? container.marine_line.name : '- - -'}</div>

                                </div>
                            </div>
 

                            <div className={ cl.containerFlex }>
                                <div className={ cl.containerDetail }>
                                    <UserI/>
                                    <div className={ cl.containerName }>აგენტი</div> 
                                    <div className={ cl.containerValue }>{container.agent ? container.agent.name : '- - -'}</div>
                                </div>
                            </div>
 

                            <div className={ cl.containerFlex }>
                                <div className={ cl.containerDetail }>
                                    <span style={{ background: '#fff' }} ></span>
                                    <div className={ cl.containerName }>სტატუსი</div> 
                                    <div className={cl.containerValue +' ' + cl.containerValueStatus}>
                                    {container.status_id ? (
                                        (() => {
                                            const status = appState.container_statuses.find(status => status.value === container.status_id);
                                            return status ? (
                                                <React.Fragment>
                                                    <span style={{ background: status.color }}></span> {status.label}
                                                </React.Fragment>
                                            ) : (
                                                '- - -'
                                            );
                                        })()
                                    ) : (
                                        '- - -'
                                    )}

                                    </div>

                                </div>
                            </div>
 
                            <div className={ cl.containerFlex } style={{ display: 'none'}}>
                                <div className={ cl.containerDetail1 }>
                                <StatusDropdown statuses={appState.container_statuses} container={container} containerService={containerService}> </StatusDropdown>
                                </div>
                            </div>
    
                            

                        </div>
                        
                        <div className={ cl.containerItem }  style={{width: '100%' }}>

                            <div className={ cl.containerFlex }>
                                <div className={ cl.containerDetail }>
                                    <Flag countryCode={container?.sender_country?.code} />
                                    <div className={ cl.containerName }>გამოსვლის პორტი</div>
                                    <div className={ cl.containerValue }>
                                        
                                    { container && container.sender_country && container?.sender_country?.code ? (
                                        <span>  {container?.sender_country?.code},  {container.sender_city.name}</span>
                                    ) : null  } 
                                    </div>
                                </div>
                            </div>
 
                            <div className={ cl.containerFlex }>
                                <div className={ cl.containerDetail }>
                                    <Flag countryCode={container?.reciever_country?.code} />
                                    <div className={ cl.containerName }>შემოსვლის პორტი</div>
                                    <div className={ cl.containerValue }> 
                                    { container && container.reciever_country && container?.reciever_country?.code ? (
                                        <span>{container?.reciever_country?.code},  {container.reciever_city.name}</span>
                                    ) : null  }
                                    </div>
                                </div>
                            </div>
 
 
                            
                            <div className={ cl.containerFlex } style={{ display: 'flex', gap: '5px' }}>

                                 
                                <div className={ cl.containerFlex } >
                                    <div className={ cl.containerDetail  }  style={{ paddingRight: '1px'}}  > 
                                        <Kilogram  style={{ marginRight: '2px'}} />  
                                        <div className={ cl.containerName }>წონა</div>
                                        <div className={ cl.containerValue } style={ { fontWeight: '600', paddingRight: 0}} >{container.gross_weight}</div>
  
                                    </div>  
                                </div>

                                <div className={ cl.containerFlex }>
                                    <div className={ cl.containerDetail  }  >
                                        
                                        
                                            {container.is_transit === 1 ? <Check/> : <Time/>} 

                                        <div className={ cl.containerName }>ტრანზიტი</div>
                                        <div className={ cl.containerValue } style={ { fontWeight: '600'}} >
                                            {container.is_transit === 1 ? 'კი' : 'არა'}
                                        </div>
                                    </div>  
                                </div>


                            </div>
                           

                            <div className={ cl.containerFlex }>
                                <div className={ cl.containerDetail }>
                                    <Flag countryCode={container?.final_destination_country?.code} />
                                    <div className={ cl.containerName }>ფინალური დანიშ.</div>
                                    <div className={ cl.containerValue }> 
                                    { container && container.final_destination_country && container?.final_destination_country?.code ? (
                                        <span>{container?.final_destination_country?.code},  {container.final_destination_city?.name}</span>
                                    ) : null  }
                                    </div>
                                </div>
                            </div>


  
 
                            <div className={ cl.containerFlex }>
                                <div className={ cl.containerDetail }>
                                    <Train/>
                                    <div className={ cl.containerName }>სახმელეთო გადაზიდვა</div>
                                    <div className={ cl.containerValue }>{getLabelById(container.land_type_id)}</div>  
                                </div>
                            </div>
 
 


                            <div className={ cl.containerFlex }>
                                <div className={ cl.containerDetail }>
                                    <Calendar/>
                                    <div className={ cl.containerName }>გამოსვლა</div>
                                    <div className={ cl.containerValue }>{ formatDate(container.send_at) || '- - -'}</div>
                                </div>
                            </div>

                            <div className={ cl.containerFlex }>
                                <div className={ cl.containerDetail }>
                                    <Calendar/>
                                    <div className={ cl.containerName }>შემოსვლა</div>
                                    <div className={ cl.containerValue }>{ formatDate(container.entry_at) || '- - -'}</div>
                                </div>
                            </div>

                            <div className={ cl.containerFlex }>
                                <div className={ cl.containerDetail }>
                                    <Calendar/>
                                    <div className={ cl.containerName }>გახსნა</div>
                                    <div className={ cl.containerValue }>{ formatDate(container.open_at) || '- - -'}</div> 
                                </div>
                            </div>

                            <div className={ cl.containerFlex }>
                                <div className={ cl.containerDetail }>
                                    <Calendar/>
                                    <div className={ cl.containerName }>დასრულება</div>
                                    <div className={ cl.containerValue }>{ formatDate(container.taken_at) || '- - -'}</div>  
                                </div>
                            </div>

                            <div className={ cl.containerFlex }>
                            </div>
   
 
                        </div>
 
                    </>}
                     
                {/* კონტეინერის ნახვა  */}
            



            <div style={{ padding: '15px 15px 5px 15px' }}>
            <div className={tbl.table + ' ' + cl.table } style={{   position: 'relative', minHeight: 'unset', overflow: 'unset'  }}>

                <table>
                        <thead>
                            <tr>  
                                <th>სახელი გვარი</th>
                                <th style={{ maxWidth: '70px', minWidth: '70px' }}>პირადი</th>
                                <th style={{ maxWidth: '70px', minWidth: '70px' }}>მობილური</th>
                                <th style={{ maxWidth: '155px', minWidth: '155px' }}>მანქანა</th>
                                <th style={{ minWidth: '106px' }} >VIN</th>
                                <th>გადასახდელი</th>
                                <th>გადახდილი</th>
                                <th>ვალი</th>
                                <th style={{ padding: '2px 5px', width: '5px' }} >

                                    {app.hasPermission("ADD_CAR") &&
                                        <>
                                            {isOpenAddCargo && openCargoIndex === index ? <span onClick={closeAddCargo} className={cl.AddBtnCargo}>
                                                <span className={cl.icon} > <Plus /></span> 
                                            </span>  : <span onClick={() => openAddCargo(index)}  className={cl.AddBtnCargo}>
                                                <span className={cl.icon} > <Plus /></span> 
                                            </span> }
                                        </>
                                    }

                                </th>

                            </tr>
                        </thead>

                        <tbody>
 
 
                            {isOpenAddCargo && openCargoIndex === index && app.hasPermission("ADD_CAR") && (
                                <AddCargoModal onCloseAddCargo={() => setIsOpenAddCargo(false)} cargoService={cargoService} containerService={containerService} defaultContainer={container} ></AddCargoModal>
                            )}

                            {container.cargos && container.cargos.length > 0 ? (
                                <>
                                    {container.cargos && container.cargos.map((cargo, indexCargo) => (
                                
                                        <> 
                                            {app.hasPermission("EDIT_CAR") && isOpenEditCargo && isOpenEditCargoIndex === index +'-'+ indexCargo ?
                                                <EditCargoModal
                                                    cargoService={cargoService} 
                                                    containerService={containerService} 
                                                    defaultContainer={container} 
                                                    defaultCargo={cargo} 
                                                    onCloseEditCargo={() => { setIsOpenEditCargo(false);  setOpenEditCargoIndex(null);  } }
                                                ></EditCargoModal>  
                                            :  
                                                <tr key={indexCargo}  
                                                
                                                    className={
                                                        (selectedCargos.some(sc => sc.id === cargo.id) ? cl.checked : ' ' )+ 
                                                        ' ' + 

                                                        (cargo.total_debt > 0 ? cl.redTable : ' ') 

                                                        + ' ' + 
                                                        (cargo.green == 1 ? cl.greenTable : ' ') 

                                                        }

                                                        style={(cargo.color && cargo.color.length > 4) ? { backgroundColor: cargo.color } : {}}

                                                        
                                                        >

                                                        <td onClick={() => handleCargoSelect(cargo)} >

                                                        <div className={cl.formCheck}>
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedCargos.some(sc => sc.id === cargo.id)}
                                                                onChange={() => handleCargoSelect(cargo)}
                                                                id={'toggleRow' + cargo.id}
                                                            />  
                                                            <label htmlFor={'toggleRow' + cargo.id} >
                                                            {cargo.name ? 
                                                                highlightText(cargo.name, searchTerm)
                                                            : '- - -'
                                                            } 
                                                            </label>
                                                        </div>

                                                            
                                                        </td>
                                                        <td onClick={() => handleCargoSelect(cargo)} >
                                                            {cargo.personal ? 
                                                                highlightText(cargo.personal, searchTerm)
                                                            : '- - -'
                                                            }
                                                        </td>
                                                        <td onClick={() => handleCargoSelect(cargo)} >
                                                        {cargo.mobile ? 
                                                                highlightText(cargo.mobile, searchTerm)
                                                            : '- - -'
                                                            }
                                                        </td>
                                                        <td onClick={() => handleCargoSelect(cargo)} >{cargo.car_info || '- - -'}</td>
                                                        <td>
                                                            {cargo.vin ? 
                                                                highlightText(cargo.vin, searchTerm)
                                                            : '- - -'
                                                            }
    
                                                            {app.hasPermission("CARGO_GREEN") 
                                                                && cargo.total_debt <= 0 
                                                                && cargo.cargo_price > 0 
                                                                && getTotalCargoPrice(container.cargos) == container.client_total_price 
                                                                && container.open_at && 
                                                                <Green
                                                                    key={cargo.id}
                                                                    cargoService={cargoService} 
                                                                    containerService={containerService} 
                                                                    cargoID={cargo.id}   
                                                                    value={cargo.green}   
                                                                /> 
                                                            }  
                                                           
                                                        </td>

                                                        <td className={getTotalCargoPrice(container.cargos) != container.client_total_price ? cl.redCompany : ''}>
                                                            {app.hasPermission("CLIENT_PRICE_SHOW") &&
                                                                <span className={ cl.cargoPrice} >
                                                                    {
                                                                        cargo.cargo_price > 0 ? cargo.cargo_price : ''
                                                                    }
                                                                </span> 
                                                                } 
                                                        </td>
                                                        <td>
                                                            {app.hasPermission("CLIENT_PAY_SHOW") &&
                                                                <CargoAmountModal cargoService={cargoService} containerService={containerService} cargo={cargo} ></CargoAmountModal>
                                                            } 
                                                        </td>
                                                        <td> 
                                                            {app.hasPermission("CLIENT_CAR_DEBT_SHOW") &&
                                                                    <span className={
                                                                    cl.cargoPrice + ' ' + 
                                                                    (cargo.total_debt > 0 ? cl.red : cl.green)
                                                                }  > 

                                                                {cargo.total_paid > 0 ?
                                                                    cargo.total_debt > 0 ? cargo.total_debt : 0 
                                                                : 
                                                                    ''
                                                                }
                                                                
 
                                                                </span>
                                                            } 
                                                        </td>

                                                        <td style={{width: '10px'}}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }} >

                                                                {cargo && 
                                                                    <>
                                                                        <CargoImageModal key={ 'CargoImageModal'+cargo.id } defaultCargo={cargo}  containerService={containerService} disabled={!app.hasPermission("PICTURE_ADD")}   ></CargoImageModal>
                                                                        <TitleFile key={ 'TitleFile'+ cargo.id } cargoService={cargoService} containerService={containerService} defaultCargo={cargo} > </TitleFile>
                                                                        <InvoiceCargo key={ 'InvoiceCargo'+ cargo.id } defaultContainer={container} defaultCargo={cargo} cargoWeight={ container.gross_weight / container.cargos.length } disabled={!app.hasPermission("INVOICE_CLIENT_SHOW")}  ></InvoiceCargo>
                                                                        <Consignment key={ 'Consignment'+ cargo.id }  defaultContainer={container} defaultCargo={cargo} cargoWeight={ container.gross_weight / container.cargos.length }  ></Consignment>

                                                                    </>
                                                                }

                                                                {
                                                                    (!container.hasOwnProperty('is_deleted') && !container.hasOwnProperty('is_archive')) && (
                                                                    <>
                                                                        
                                                                        <span className={ cl.EditBtn } onClick={() => openRemarkModal(cargo.color, cargo.id, 2)}><Comment/></span>
                                                                        {app.hasPermission("EDIT_CAR") &&
                                                                            <span className={ cl.EditBtn } onClick={() => openEditCargo(index +'-'+ indexCargo)}><Pen/></span>
                                                                        }
                                                                        {app.hasPermission("DELETE_CAR") && 
                                                                            <CargoDeleteModal key={ 'CargoDeleteModal'+ cargo.id } cargoService={cargoService} containerService={containerService} defaultCargo={cargo} ></CargoDeleteModal>
                                                                        } 

                                                                    </>
                                                                    )
                                                                }

                                                            </div>
                                                        </td>
                                                </tr> } 
                                        </>
                                        
                                    ))}
                                </> 
                            ) : ('' )}

                            <tr className={getTotalCargoDebt(container.cargos) > 0 ? cl.redTable : ''} >
                             
                                <td style={{ textAlign: 'right' }} colSpan={5}>კლიენტების ჯამი</td>
                                <td style={{ maxWidth: '120px' }} className={ container.total_price > container.client_total_price ? cl.redCompany : '' } > 

                                    
                                    {app.hasPermission("CLIENT_PRICE_SHOW") &&

                                        <>
           
                                                    {isOpenEdit && openEditIndex === index ? 
                                                        <> 
                                                            <span  className={ cl.cargoPrice} style={{ marginRight: '5px' }} >
                                                                { clientPrice } 
                                                            </span> 
                                                        </>
                                                    : 
                                                        <> 
                                                            {isOpenClientPrice && openClientPriceIndex === index && app.hasPermission("TRANSPORT_PRICE_EDIT_CLIENT")? 
                                                                <>   

                                                                    <span style={{ marginRight: '5px', cursor:'pointer' }} className={ cl.cargoPrice} onClick={() => { openClientPrice(null);  setOpenClientPriceIndex(null);  }}  >
                                                                            {container.client_total_price}
                                                                    </span> 

                                                                    {app.hasPermission("TRANSPORT_PRICE_EDIT_CLIENT") &&
                                                                        <>  
                                                                            <TransportPrice
                                                                                containerService={containerService}
                                                                                defaultContainer={container}
                                                                                isCompanyPrice={false}
                                                                                typeOfPrice={'clientPrice'}
                                                                                onCloseTransportPrice={() => {  openClientPrice(null);  setOpenClientPriceIndex(null);  } } 
                                                                            />

                                                                        </>
                                                                    }
                                                                    
                                                                </>     
                                                            : 
                                                                <>
                                                                    <div  style={{ display: 'flex' }}>
                                                                        <>
                                                                            <span onClick={() => { openClientPrice(index);  setOpenClientPriceIndex(index);  }} className={ cl.cargoPrice} style={{ marginRight: '5px' }} >
                                                                                {container.client_total_price} 
                                                                            </span> 

                                                                            <Popover content={(
                                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                                    <div style={{ marginBottom: '5px', color: 'var(--text-color)' }}>გსურთ გადანაწილება? </div> 
                                                                                    <span className={ cl.YesBtn} onClick={(event) => {
                                                                                        handleRedistribute();
                                                                                        event.stopPropagation(); // Prevents the popover from toggling when the button inside it is clicked
                                                                                        event.target.closest('div[style*="position: absolute"]').previousSibling.click(); // Simulates clicking the trigger to close
                                                                                    }}>
                                                                                        კი, მსურს 
                                                                                    </span>
                                                                                </div>
                                                                            )}>
                                                                                <div className={ cl.RedistributeBTN } > <ArrowFork/> </div> 
                                                                            </Popover> 
                                                                        </>  
                                                                    </div>
                                                                </>
                                                            }

                                                        </>
                                                    }
  
                                        </>
                                    }
                                </td>
                                <td>
                                    {app.hasPermission("CLIENT_PAY_SHOW") &&
                                        <>  
                                            <span  style={{fontWeight: 'bold'}}>  
                                                {
                                                    container.client_total_paid === 0 ? ' ' : container.client_total_paid
                                                }

                                            </span>  
                                        </>
                                    }
                                </td>
                                <td>
                                    {app.hasPermission("CLIENT_DEBT_SHOW") &&
                                        <> 
                                                <span className={
                                                    cl.cargoPrice + ' ' + 
                                                    (container.client_debt > 0 ? cl.red : cl.green)
                                                } >  

                                                    {container.client_debt}

                                                
                                                </span> 
 
                                        </>
                                    }
                                </td> 
                                <td> </td>  
                            </tr>
                                
                            <tr className={container.company_debt > 0 ? cl.redTable : ''} >
                                <td style={{ padding: '2px 5px 0px 5px'}}> 
                                    <BankModal container={container} containerService={containerService}> </BankModal>
                                </td>
                                <td style={{ textAlign: 'right' }} colSpan={4}>კომპანია</td>
                                <td style={{ maxWidth: '121px' }} className={ container.total_price > container.client_total_price ? cl.redCompany : '' }>  

                                    {app.hasPermission("COMPANY_PRICE_SHOW") &&
                                        <>


                                                    {isOpenEdit && openEditIndex === index ? 
                                                        <> 
                                                            <span className={cl.companyPrice}    >
                                                                { companyPrice }
                                                            </span> 
                                                        </>
                                                    : 
                                                        <> 
                                                            {isOpenCompanyPrice && openCompanyPriceIndex === index ? 
                                                                <>    
                                                                    <div className={cl.companyPrice} style={{  fontWeight: 'bold' }}  onClick={() => { openCompanyPrice(null);  setOpenCompanyPriceIndex(null);  }}  >{container.total_price  }</div> 
                                                                  
                                                                    {app.hasPermission("TRANSPORT_PRICE_EDIT_COMPANY") &&
                                                                        <> 
                                                                        <TransportPrice
                                                                        containerService={containerService}
                                                                        defaultContainer={container}
                                                                        isCompanyPrice={false}
                                                                        typeOfPrice={'companyPrice'}
                                                                        onCloseTransportPrice={() => { openCompanyPrice(null);  setOpenCompanyPriceIndex(null);  } } 
                                                                        />
                                                                    </>
                                                                    }
                                                                    

                                                                </>     
                                                            : 
                                                                <> 
                                                                    <span className={cl.companyPrice}  onClick={() => { openCompanyPrice(index);  setOpenCompanyPriceIndex(index);  }} >
                                                                        {container.total_price  } 
                                                                    </span>    

                                                                </>
                                                            }

                                                        </>
                                                    }



    
                                        </>
                                             
                                    }
    
                                </td>
                                <td>
                                    {app.hasPermission("COMPANY_PAY_SHOW") &&
                                        <>
                                            <ContainerAmountModal containerService={containerService} container={container} ></ContainerAmountModal>
                                        </>
                                    }
                                </td>
                                <td>   
                                {app.hasPermission("COMPANY_DEBT_SHOW") &&
                                    <>                              
                                        <span className={ cl.cargoPrice + ' ' + 
                                                (container.company_debt > 0 ? cl.red : cl.green)
                                            }  > 
                                            
                                            {container.total_paid > 0 ?
                                                container.company_debt > 0 ? container.company_debt : container.company_debt 
                                            : 
                                                ''
                                            }
 
                                        </span> 
                                    </>
                                }
                                </td>
                                <td> </td> 
                            </tr>
                        </tbody>
                </table>
            </div>
            </div>
            <div className={ cl.created_at }>Შეიქმნა: { formatDate(container.created_at) || '- - -'} ID:   { container.id || '- - -'}</div> 
        </div> 

  
    
    
  </>;
}
 
export default Item;